import { get } from 'lodash-es';
import React from 'react';
import styled from 'styled-components';
import { decodeDocument } from "@sunbit-dev/common/helpers/documents";

// tslint:disable-next-line:variable-name
const SHtmlViewer = styled.div<{ padding?: number }>`
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
`;

// tslint:disable-next-line:variable-name
const SHtmlFrame = styled.iframe`
  width: 100%;
  border: 0;
`;

interface IHtmlViewerProps {
  padding?: number;
  content?: string;
}

export default class HtmlViewer extends React.Component<IHtmlViewerProps, { iframeSrc: string }> {
  private iframeRef: React.RefObject<HTMLIFrameElement>;

  constructor(props: IHtmlViewerProps) {
    super(props);
    this.iframeRef = React.createRef();
    this.state = {
      iframeSrc: 'about:blank',
    };
  }

  public componentDidMount() {
    const iframe = this.iframeRef.current;
    this.setIframeSrc();
    if (iframe) {
      iframe.addEventListener('load', () => {
        iframe.style.height = `${get(iframe, 'contentWindow.document.body.scrollHeight', '0')}px`;

        // Warning - magic before you:
        // Do not remove this line, for some reason, the height meausrment is incorrect when calling this only once
        // you can try it yourself, I had no time to really dig into it...
        iframe.style.height = `${get(iframe, 'contentWindow.document.body.scrollHeight', '0')}px`;
        iframe.setAttribute('data-loaded', 'true');
      });
    }
  }

  public componentDidUpdate(prevProps: IHtmlViewerProps) {
    if (prevProps.content !== this.props.content) {
      this.setIframeSrc();
    }
  }

  private setIframeSrc() {
    if (this.props.content) {
      this.setState(() => ({ iframeSrc: decodeDocument(this.props.content || '') }));
    }
  }

  public render() {
    return (
      <SHtmlViewer padding={this.props.padding}>
        <SHtmlFrame style={{ width: '100%' }} data-at="htmlViewer" data-loaded="false" marginWidth={0} ref={this.iframeRef} srcDoc={this.state.iframeSrc} frameBorder="0" scrolling="no">
          The iframe tag is not supported by your browser.
        </SHtmlFrame>
      </SHtmlViewer>
    );
  }
}
